var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "pui-card",
        { attrs: { title: "" } },
        [
          _c(
            "pui-grid-container",
            [
              _c("pui-grid-row", [
                _vm._v(" " + _vm._s(_vm.errorResponse) + " "),
              ]),
              _vm.pageReloadTimeout !== undefined
                ? _c("pui-grid-row", [
                    _c(
                      "h3",
                      {
                        staticClass: "pt-2",
                        staticStyle: { width: "100%", "text-align": "center" },
                      },
                      [_vm._v(" " + _vm._s(_vm.reloadIn) + " ")]
                    ),
                  ])
                : _vm._e(),
              _vm.buttonIsVisible
                ? _c(
                    "pui-grid-row",
                    { staticClass: "button" },
                    [
                      _c(
                        "pui-button",
                        {
                          staticClass: "mt-3",
                          on: {
                            click: function ($event) {
                              return _vm.buttonFunction()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.buttonLabel) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }